<template>
  <div ref="vehicleImport">
    <b-input-group size="sm" class="mb-2">
      <b-button
        size="sm"
        variant="outline-info"
        class="mr-2"
        @click="openDialog()"
      >
        <i class="el-icon-success"></i> 下载模板
      </b-button>
      <el-upload
        action="/vehicle/info/vehicleImport"
        ref="upload"
        :http-request="uploadFile"
        :show-file-list="false"
      ><!--update file-->
        <b-button size="sm" class="mr-2" variant="outline-success">
          <i class="el-icon-upload"></i> 选择文件
        </b-button>
      </el-upload>
      <b-button
        size="sm"
        variant="outline-primary"
        @click="saveVehicle()"
        v-if="display"
      >
        <i class="el-icon-receiving"></i> 确认导入
      </b-button>
    </b-input-group>
    <vxe-grid
      ref="table"
      highlight-hover-row
      :columns="tableColumns"
      :row-class-name="rowClassName"
      :data="tableData"
      :height="tableHeight"
      size="small"
      resizable
      border
    >
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="rowStatus === '已导入' ? 'light' : 'warning'"
        >
          <span
            size="mini"
            v-text="row.errorMsg ? '数据解析异常' : '数据解析成功'"
          >
          </span>
        </el-tag>
      </template>
      <!-- <template v-slot:receiveSign="{row}">
        <span size="mini" v-text="row.receiveSign === '是'? '是' : row.receiveSign === ''? '否': '非法参数'">
          {{ row.receiveSign }}
        </span>
      </template>
      <template v-slot:receiveBill="{row}">
        <span size="mini" v-text="row.receiveBill === 1 ? '是' : '否'">
          {{ row.receiveBill }}
        </span>
      </template>

      <template v-slot:pickupSign="{row}">
        <span size="mini" v-text="row.pickupSign === 1 ? '是' : '否'">
          {{ row.pickupSign }}
        </span>
      </template>

      <template v-slot:pickupBill="{row}">
        <span size="mini" v-text="row.pickupBill === 1 ? '是' : '否'">
          {{ row.pickupBill }}
        </span>
      </template>
      <template v-slot:isBack="{row}">
        <span size="mini" v-text="row.isBack === 1 ? '是' : '否'">
          {{ row.isBack }}
        </span>
      </template>
      
      <template v-slot:isMatchingContract="{row}">
        <span size="mini" v-text="row.isMatchingContract === 1 ? '是' : '否'">
          {{ row.isMatchingContract }}
        </span>
      </template> -->
    </vxe-grid>

    <el-dialog
      v-if="dialogOptions.visible"
      v-el-dialog-drag
      show-close
      width="1000px"
      visible
      :title="dialogOptions.title"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <order-table />
      <br />
    </el-dialog>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
import OrderTable from '../detail/index'
export default {
  mixins: [TableAutoHeight],
  components: {
    OrderTable
  },
  data() {
    return {
      tableColumns: tableColumns(),
      dialogOptions: {
        visible: false,
        title: '选择车辆模板'
      },
      loading: false,
      tableData: [],
      allData: [],
      successData: [],
      // goodsDatas: [],
      display: true,
      fileName: '',
      rowStatus: ({ row }) => {
        if (row.errorMsg) {
          return '数据解析异常'
        }
        return row.saveStatus
      },
      rowClassName: ({ row }) => {
        if (row.errorMsg) {
          return 'bg-danger text-white'
        }
        return ''
      }
    }
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 170
    },
    openDialog() {
      this.dialogOptions.visible = true
    },
    uploadFile(params) {
      this.display = true
      this.fileName = params.file.name
      const loading = this.$loading({
        target: this.$refs.vehicleImport,
        lock: true,
        text: '正在解析文件数据',
        spinner: 'el-icon-loading'
      })

      return this.$api
        .VEHICLE_UPLOAD(params.file, this.fileName)
        .then((res) => {
          loading.close()
          this.tableData = res.body.allData
          this.allData = res.body.allData
          this.successData = res.body.successData
        })
        .catch(() => loading.close())
    },
    handleClose() {
      this.dialogOptions.visible = false
    },

    saveVehicle() {
      if (this.successData.length <= 0) {
        return this.$message({
          showClose: true,
          message: '无有效车辆可保存',
          type: 'warning'
        })
      }
      this.display = false
      let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$api
        .bizVehicleImportDataSaveApi({ dataSaveVoList: this.successData })
        .then((res) => {
           loadingInstance.close()
          let flag = res.body.flag
          if ('Y' === flag) {
            this.$message({
              showClose: true,
              message: '导入成功！',
              type: 'success'
            })
          } else {
            //orderData.exception = res.body.exception
          }
        })
        .catch(() => {
          loadingInstance.close()
        })
      // })

      this.tableData = []
    }
  }
}
</script>
